<div class="tabs" style="margin-top: 10px;">
  <!-- Radios (Margin is default) -->
  <input type="radio" id="tab-margin" name="tab-control" checked />
  <input type="radio" id="tab-upload" name="tab-control" />
  <input type="radio" id="tab-change-pass" name="tab-control" />
  <input type="radio" id="tab-change-default-cost" name="tab-control" />
  <input type="radio" id="tab-change-projectbaintargets" name="tab-control" />
  <input type="radio" id="tab-change-baintargets" name="tab-control" />
  <input type="radio" id="tab-change-practicearea" name="tab-control" />

  <!-- Tab headers -->
  <ul>
    <li><label for="tab-margin" role="button">Margin Data</label></li>
    <li><label for="tab-upload" role="button">Cost Data</label></li>
    <li><label for="tab-change-pass" role="button">Change Passphrase</label></li>
    <li><label for="tab-change-default-cost" role="button">Default Cost</label></li>
    <li><label for="tab-change-projectbaintargets" role="button">Project Bain Targets</label></li>
    <li><label for="tab-change-baintargets" role="button">Bain Targets</label></li>
    <li><label for="tab-change-practicearea" role="button">Practice Area</label></li>
  </ul>

  <!-- Panels -->
  <div class="content">
    <!-- =========================
         TAB 1: Margin Upload
         ========================= -->
    <section data-tab="margin">
      <div class="excel-upload-container">
        <!-- File input -->
        <div class="file-input-row" style="display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; gap: 16px;">
          <div style="flex: 1; min-width: 0;">
            <label for="excelFile">Select Excel file</label>
            <input
              #excelFile
              id="excelFile"
              type="file"
              accept=".xlsx"
              (change)="onFileChange($event)"
              [disabled]="isValidating || isUploadingMargin"
              aria-label="Upload Excel file"
            />
            <small>Accepted types: .xlsx</small>
          </div>
          <!-- Last Updated Info for Margin -->
          <div *ngIf="lastUpdatedOnMargin || lastUpdatedOnFocus" style="display: flex; flex-direction: column; align-items: flex-end; gap: 8px; justify-content: flex-start;">
            <small>Last updated on GM: {{ lastUpdatedOnMargin | date: 'dd/MM/yyyy' }}</small>
            <small>Last updated on Focus: {{ lastUpdatedOnFocus | date: 'dd/MM/yyyy' }}</small>
          </div>
        </div>

        <!-- Selected file info -->
        <div *ngIf="selectedFileName" class="file-info">
          <div><strong>File:</strong> {{ selectedFileName }}</div>
          <div *ngIf="selectedFileSize">
            <strong>Size:</strong> {{ selectedFileSize }} bytes
          </div>
        </div>

        <!-- Error message (Margin-specific) -->
        <div *ngIf="marginErrorMessage" class="message error">{{ marginErrorMessage }}</div>

        <!-- Actions -->
        <div class="actions">
          <button
            type="button"
            class="upload-btn"
            (click)="uploadExcel()"
            [disabled]="!canUpload || isUploadingMargin || isValidating"
          >
            Upload
          </button>

          <button
            type="button"
            class="btn-clear"
            (click)="clearSelection()"
            [disabled]="isValidating || isUploadingMargin"
          >
            Clear
          </button>
        </div>

        <br />

        <!-- Validation summary -->
        <div *ngIf="validationSummary" class="alert alert-danger">
          {{ validationSummary }}
        </div>

        <!-- Validation Table -->
        <div *ngIf="validationRows?.length" class="validation-table-wrapper">
          <table class="validation-table">
            <thead>
              <tr>
                <th *ngFor="let col of validationColumns">{{ col }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of validationRows">
                <td *ngFor="let col of validationColumns">
                  {{ row[col] }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Success (Margin-specific) -->
        <div *ngIf="marginSuccessMessage" class="alert alert-success">
          {{ marginSuccessMessage }}
        </div>
      </div>

      <!-- 🔄 Scoped overlay for Margin only -->
      <div
        class="overlay"
        *ngIf="isValidating || isUploadingMargin"
        aria-live="polite"
        aria-busy="true"
        role="status"
      >
        <div class="spinner" aria-hidden="true"></div>
        <div class="overlay-text">
          {{ isValidating ? 'Validating workbook…' : 'Uploading file…' }}
        </div>
      </div>
    </section>

    <!-- =========================
         TAB 2: Upload Cost Data
         ========================= -->
    <section data-tab="upload" style="margin-left: 15px;">
      <!-- Inline messages -->
      <div *ngIf="errorMessage" class="error" role="alert">{{ errorMessage }}</div>
      <div *ngIf="successMessage" class="success" role="status" aria-live="polite">
        {{ successMessage }}
      </div>

      <!-- File selection (Bootstrap input group) -->
      <div class="form-row">
          <input
            #nativeCostFileInput
            class="native-file-input"
            type="file"
            accept=".xlsx,.xls"
            (change)="onFileSelected($event)"
            aria-label="Choose Excel file"
            [disabled]="isUploading || isSavingPass"
          />

          <!-- Visible input group (shows filename + browse button) -->
          <div class="input-group file-input-group">
            <span class="input-group-text" id="file-addon">File</span>
            <input
              type="text"
              class="form-control"
              [value]="file?.name || ''"
              placeholder="Select .xlsx or .xls file"
              aria-describedby="file-addon"
              aria-readonly="true"
              readonly
            />
            <button
              class="btn btn-outline-secondary"
              type="button"
              (click)="openNativeFileDialog()"
              [disabled]="isUploading || isSavingPass"
              [attr.aria-label]="'Browse files'"
              title="Browse files"
            >
              <!-- paperclip icon -->
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                   fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                <path d="M.5 6.5A3.5 3.5 0 0 1 4 3h7.5a2.5 2.5 0 1 1 0 5H6a1.5 1.5 0 0 1 0-3h5.5a.5.5 0 0 0 0-1H6a2.5 2.5 0 1 0 0 5h5.5a3.5 3.5 0 1 0 0-7H4A4.5 4.5 0 0 0-.5 6.5a4.5 4.5 0 1 0 9 0V4a.5.5 0 0 1 1 0v2.5a5.5 5.5 0 1 1-11 0Z"/>
              </svg>
              <span class="ms-1">Browse</span>
            </button>
          </div>

        <!-- Download Sample Excel & Last Updated -->
        <div style="margin-left: 43%;">
          <a
            class="btn btn-link px-0"
            href="assets/samples/payroll_sample_upload.xlsx"
            download="payroll_sample_upload.xlsx"
            [attr.aria-label]="'Download sample Excel'"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
              <path d="M.5 9.9v2.6A2.5 2.5 0 0 0 3 15h10a2.5 2.5 0 0 0 2.5-2.5V9.9a.5.5 0 0 0-1 0v2.6A1.5 1.5 0 0 1 13 14H3a1.5 1.5 0 0 1-1.5-1.5V9.9a.5.5 0 0 0-1 0z"/>
              <path d="M7.646 10.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 9.293V1.5a.5.5 0 0 0-1 0v7.793L5.354 7.146a.5.5 0 1 0-.708.708l3 3z"/>
            </svg>
            <span class="ms-1">Download sample Excel</span>
          </a>
        </div>
      </div>

      <!-- Passphrase (Bootstrap input group with eye toggle) -->
      <div class="form-row">
        <label for="uploadPassInline" class="sr-only">Passphrase</label>
        <div class="input-group pass-input-group">
          <span class="input-group-text" id="pass-addon">Passphrase</span>
          <input
            #uploadPassInput
            id="uploadPassInline"
            class="form-control"
            [type]="showUploadPass ? 'text' : 'password'"
            placeholder="Enter passphrase (required)"
            autocomplete="off"
            aria-required="true"
            aria-describedby="pass-addon"
            [disabled]="isUploading || isSavingPass"
          />
          <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="toggle('upload')"
            [attr.aria-label]="showUploadPass ? 'Hide passphrase' : 'Show passphrase'"
            [attr.aria-pressed]="showUploadPass"
            [disabled]="isUploading || isSavingPass"
            title="{{ showUploadPass ? 'Hide' : 'Show' }}"
          >
            <svg *ngIf="!showUploadPass" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                 fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
              <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8ZM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.827 8a13.133 13.133 0 0 1-1.66 2.043c-.261.26-.54.508-.834.744l-.974-.549Z"/>
              <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"/>
            </svg>
            <svg *ngIf="showUploadPass" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                 fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
              <path d="M13.359 11.238C14.32 10.337 15.078 9.262 15.5 8c-.858-2.572-3.5-5.5-7.5-5.5a7.028 7.028 0 0 0-2.79.588l.746.746A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.827 8a13.133 13.133 0 0 1-1.66 2.043c-.261.26-.54.508-.834.744l-.974-.549Z"/>
              <path d="M11.297 9.176a3.5 3.5 0 0 0-4.473-4.473l.823.823a2.5 2.5 0 0 1 2.827 2.827l.823.823ZM3.35 5.469c-.68.57-1.262 1.238-1.72 1.997A13.133 13.133 0 0 0 1.173 8c.363.974 1.043 2.007 2.01 2.977C4.474 12.332 6.235 13.5 8.355 13.5c.773 0 1.5-.17 2.156-.473l.749.421c-.881.36-1.835.552-2.905.552-4 0-6.642-2.928-7.5-5.5.36-1.08 1.081-2.234 2.111-3.2l.384.169Z"/>
              <path d="m2.146 1.146 12.708 12.708-.708.708L1.438 1.854l.708-.708Z"/>
            </svg>
          </button>
        </div>
        <div style="margin-left: 52%;">
         <label *ngIf="lastUpdatedOnCost">
            <small>Last updated on: {{ lastUpdatedOnCost | date: 'dd/MM/yyyy' }}</small>
          </label>
        </div>
      </div>

      <!-- Upload & Clear actions -->
      <div class="mt-2">
        <button
          class="btn btn-primary"
          (click)="uploadToServer()"
          [disabled]="!file || isUploading || isSavingPass"
          [attr.aria-busy]="isUploading"
        >
          <span class="spinner-border spinner-border-sm me-1" *ngIf="isUploading" role="status" aria-hidden="true"></span>
          <span>{{ isUploading ? 'Uploading…' : 'Upload Payroll Data' }}</span>
        </button>

        <!-- Clear button -->
        <button
          class="btn btn-secondary ms-2"
          type="button"
          (click)="onClearClick()"
          [disabled]="isUploading || isSavingPass"
          title="Clear selected file, preview and messages"
          aria-label="Clear selected file, preview and messages"
        >
          Clear
        </button>
      </div>

      <!-- Optional: show detailed structure issues -->
      <div *ngIf="!isFileStructValid && structureIssues.length" class="text-danger mt-2" aria-live="polite">
        <ul class="mb-0">
          <li *ngFor="let i of structureIssues">{{ i }}</li>
        </ul>
      </div>

      <!-- ❌ Error rows returned by API -->
      <div *ngIf="missingUsers.length" class="error-table-block" aria-live="polite">
        <h4 class="error">
          {{ missingUsers.length }} row(s) contain invalid employee details
        </h4>

        <div class="hint muted">
          Please correct Employee ID in the Excel file and re-upload.
        </div>

        <div class="table-wrapper">
          <table class="table table-sm table-striped table-hover align-middle data-table">
            <thead class="table-light">
              <tr>
                <th>#</th>
                <th>Employee ID</th>
                <th>Currency</th>
                <th>Error Reason</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let u of missingUsers; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ u.payroll_ctempid }}</td>
                <td>{{ u.payroll_currency }}</td>
                <td>{{ u.ErrorAtInsert }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 🔄 Scoped overlay for Cost Upload only -->
      <div
        class="overlay"
        *ngIf="isUploading"
        aria-live="polite"
        aria-busy="true"
        role="status"
      >
        <div class="overlay-spinner" aria-hidden="true"></div>
        <div class="overlay-text">
          Uploading…
        </div>
      </div>
    </section>

    <!-- =========================
         TAB 3: Change Passphrase
         ========================= -->
    <section data-tab="change-pass" style="margin-left: 15px;">
      <!-- Current passphrase -->
      <div class="form-row">
        <label for="currentPass" class="form-label">Current passphrase</label>
        <div class="input-group pass-input-group">
          <input
            #currentPassInput
            id="currentPass"
            class="form-control"
            [type]="showCurrentPass ? 'text' : 'password'"
            autocomplete="current-password"
            placeholder="Enter current passphrase"
            [disabled]="isUploading || isSavingPass"
          />
          <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="toggle('current')"
            [attr.aria-label]="showCurrentPass ? 'Hide current passphrase' : 'Show current passphrase'"
            [attr.aria-pressed]="showCurrentPass"
            [disabled]="isUploading || isSavingPass"
            title="{{ showCurrentPass ? 'Hide' : 'Show' }}"
          >
            <svg *ngIf="!showCurrentPass" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                 fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
              <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8ZM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.827 8a13.133 13.133 0 0 1-1.66 2.043c-.261.26-.54.508-.834.744l-.974-.549Z"/>
              <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"/>
            </svg>
            <svg *ngIf="showCurrentPass" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                 fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
              <path d="M13.359 11.238C14.32 10.337 15.078 9.262 15.5 8c-.858-2.572-3.5-5.5-7.5-5.5a7.028 7.028 0 0 0-2.79.588l.746.746A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.827 8a13.133 13.133 0 0 1-1.66 2.043c-.261.26-.54.508-.834.744l-.974-.549Z"/>
              <path d="M11.297 9.176a3.5 3.5 0 0 0-4.473-4.473l.823.823a2.5 2.5 0 0 1 2.827 2.827l.823.823ZM3.35 5.469c-.68.57-1.262 1.238-1.72 1.997A13.133 13.133 0 0 0 1.173 8c.363.974 1.043 2.007 2.01 2.977C4.474 12.332 6.235 13.5 8.355 13.5c.773 0 1.5-.17 2.156-.473l.749.421c-.881.36-1.835.552-2.905.552-4 0-6.642-2.928-7.5-5.5.36-1.08 1.081-2.234 2.111-3.2l.384.169Z"/>
              <path d="m2.146 1.146 12.708 12.708-.708.708L1.438 1.854l.708-.708Z"/>
            </svg>
          </button>
        </div>
         <label *ngIf="lastUpdatedOnChangePass" style="margin-left: 42%;">
            <small>Last updated on: {{ lastUpdatedOnChangePass | date: 'dd/MM/yyyy' }}</small>
          </label>
      </div>

      <!-- New passphrase -->
      <div class="form-row">
        <label for="newPass" class="form-label">New passphrase</label>
        <div class="input-group pass-input-group">
          <input
            #newPassInput
            id="newPass"
            class="form-control"
            [type]="showNewPass ? 'text' : 'password'"
            autocomplete="new-password"
            placeholder="Enter new passphrase"
            [disabled]="isUploading || isSavingPass"
          />
          <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="toggle('new')"
            [attr.aria-label]="showNewPass ? 'Hide new passphrase' : 'Show new passphrase'"
            [attr.aria-pressed]="showNewPass"
            [disabled]="isUploading || isSavingPass"
            title="{{ showNewPass ? 'Hide' : 'Show' }}"
          >
            <!-- eye icons (omitted for brevity, same as above) -->
            <svg *ngIf="!showNewPass" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                 fill="currentColor" viewBox="0 0 16 16" aria-hidden="true"><path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8Z"/><path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"/></svg>
            <svg *ngIf="showNewPass" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                 fill="currentColor" viewBox="0 0 16 16" aria-hidden="true"><path d="M13.359 11.238C14.32 10.337 15.078 9.262 15.5 8c-.858-2.572-3.5-5.5-7.5-5.5a7.028 7.028 0 0 0-2.79.588l.746.746Z"/><path d="m2.146 1.146 12.708 12.708-.708.708L1.438 1.854l.708-.708Z"/></svg>
          </button>
        </div>
      </div>

      <!-- Confirm new passphrase -->
      <div class="form-row">
        <label for="confirmNewPass" class="form-label">Confirm new passphrase</label>
        <div class="input-group pass-input-group">
          <input
            #confirmNewPassInput
            id="confirmNewPass"
            class="form-control"
            [type]="showConfirmNewPass ? 'text' : 'password'"
            autocomplete="new-password"
            (keyup.enter)="saveNewPassphrase()"
            placeholder="Re-enter new passphrase"
            [disabled]="isUploading || isSavingPass"
          />
          <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="toggle('confirm')"
            [attr.aria-label]="showConfirmNewPass ? 'Hide confirm passphrase' : 'Show confirm passphrase'"
            [attr.aria-pressed]="showConfirmNewPass"
            [disabled]="isUploading || isSavingPass"
            title="{{ showConfirmNewPass ? 'Hide' : 'Show' }}"
          >
            <!-- eye icons (omitted for brevity) -->
            <svg *ngIf="!showConfirmNewPass" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                 fill="currentColor" viewBox="0 0 16 16" aria-hidden="true"><path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8Z"/><path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"/></svg>
            <svg *ngIf="showConfirmNewPass" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                 fill="currentColor" viewBox="0 0 16 16" aria-hidden="true"><path d="M13.359 11.238C14.32 10.337 15.078 9.262 15.5 8c-.858-2.572-3.5-5.5-7.5-5.5a7.028 7.028 0 0 0-2.79.588l.746.746Z"/><path d="m2.146 1.146 12.708 12.708-.708.708L1.438 1.854l.708-.708Z"/></svg>
          </button>
        </div>
      </div>

      <div class="form-row">
        <button
          class="btn btn-primary"
          (click)="saveNewPassphrase()"
          [disabled]="!canSaveNewPassphrase() || isSavingPass || isUploading"
          [attr.aria-busy]="isSavingPass"
        >
          <span class="spinner-border spinner-border-sm me-1" *ngIf="isSavingPass" role="status" aria-hidden="true"></span>
          <span>{{ isSavingPass ? 'Saving…' : 'Save Passphrase' }}</span>
        </button>
      </div>

      <div class="error" *ngIf="passChangeError">{{ passChangeError }}</div>
      <div class="success" *ngIf="passChangeSuccess">{{ passChangeSuccess }}</div>

      <!-- 🔄 Scoped overlay for Passphrase only -->
      <div
        class="overlay"
        *ngIf="isSavingPass"
        aria-live="polite"
        aria-busy="true"
        role="status"
      >
        <div class="overlay-spinner" aria-hidden="true"></div>
        <div class="overlay-text">
          Saving…
        </div>
      </div>
    </section>

    <!-- =========================
         TAB 4: Upload Default Cost
         ========================= -->
    <section data-tab="change-default-cost" style="margin-left: 15px;">
      <app-default-cost-upload></app-default-cost-upload>
    </section>

    <!-- =========================
         TAB 5: Upload Project Bain Targets
         ========================= -->
    <section data-tab="change-projectbaintargets" style="margin-left: 15px;">
      <app-project-bain-targets-upload></app-project-bain-targets-upload>
    </section>

    <!-- =========================
         TAB 6: Upload Bain Targets
         ========================= -->
    <section data-tab="change-baintargets" style="margin-left: 15px;">
      <app-bain-targets-upload></app-bain-targets-upload>
    </section>

    <!-- =========================
         TAB 7: Upload Practice Area
         ========================= -->
    <section data-tab="change-practicearea" style="margin-left: 15px;">
      <app-practice-area-upload></app-practice-area-upload>
    </section>

  </div>
</div>